// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file livekit_metrics.proto (package livekit, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_logger_options } from "./logger/options_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file livekit_metrics.proto.
 */
export const file_livekit_metrics: GenFile = /*@__PURE__*/
  fileDesc("ChVsaXZla2l0X21ldHJpY3MucHJvdG8SB2xpdmVraXQiygEKDE1ldHJpY3NCYXRjaBIYCgx0aW1lc3RhbXBfbXMYASABKANCAjABEjgKFG5vcm1hbGl6ZWRfdGltZXN0YW1wGAIgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIQCghzdHJfZGF0YRgDIAMoCRIuCgt0aW1lX3NlcmllcxgEIAMoCzIZLmxpdmVraXQuVGltZVNlcmllc01ldHJpYxIkCgZldmVudHMYBSADKAsyFC5saXZla2l0LkV2ZW50TWV0cmljIocBChBUaW1lU2VyaWVzTWV0cmljEg0KBWxhYmVsGAEgASgNEhwKFHBhcnRpY2lwYW50X2lkZW50aXR5GAIgASgNEhEKCXRyYWNrX3NpZBgDIAEoDRImCgdzYW1wbGVzGAQgAygLMhUubGl2ZWtpdC5NZXRyaWNTYW1wbGUSCwoDcmlkGAUgASgNInEKDE1ldHJpY1NhbXBsZRIYCgx0aW1lc3RhbXBfbXMYASABKANCAjABEjgKFG5vcm1hbGl6ZWRfdGltZXN0YW1wGAIgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBINCgV2YWx1ZRgDIAEoAiLkAgoLRXZlbnRNZXRyaWMSDQoFbGFiZWwYASABKA0SHAoUcGFydGljaXBhbnRfaWRlbnRpdHkYAiABKA0SEQoJdHJhY2tfc2lkGAMgASgNEh4KEnN0YXJ0X3RpbWVzdGFtcF9tcxgEIAEoA0ICMAESIQoQZW5kX3RpbWVzdGFtcF9tcxgFIAEoA0ICMAFIAIgBARI+Chpub3JtYWxpemVkX3N0YXJ0X3RpbWVzdGFtcBgGIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASQQoYbm9ybWFsaXplZF9lbmRfdGltZXN0YW1wGAcgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEgBiAEBEhAKCG1ldGFkYXRhGAggASgJEgsKA3JpZBgJIAEoDUITChFfZW5kX3RpbWVzdGFtcF9tc0IbChlfbm9ybWFsaXplZF9lbmRfdGltZXN0YW1wIsUCChZNZXRyaWNzUmVjb3JkaW5nSGVhZGVyEhoKB3Jvb21faWQYASABKAlCCbpQBnJvb21JRBIUCghkdXJhdGlvbhgDIAEoBEICMAESLgoKc3RhcnRfdGltZRgEIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASQAoJcm9vbV90YWdzGAUgAygLMi0ubGl2ZWtpdC5NZXRyaWNzUmVjb3JkaW5nSGVhZGVyLlJvb21UYWdzRW50cnkSEQoJcm9vbV9uYW1lGAYgASgJEjMKD3Jvb21fc3RhcnRfdGltZRgHIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASDgoGam9iX2lkGAggASgJGi8KDVJvb21UYWdzRW50cnkSCwoDa2V5GAEgASgJEg0KBXZhbHVlGAIgASgJOgI4ASqBBwoLTWV0cmljTGFiZWwSEwoPQUdFTlRTX0xMTV9UVEZUEAASEwoPQUdFTlRTX1NUVF9UVEZUEAESEwoPQUdFTlRTX1RUU19UVEZCEAISKAokQ0xJRU5UX1ZJREVPX1NVQlNDUklCRVJfRlJFRVpFX0NPVU5UEAMSMQotQ0xJRU5UX1ZJREVPX1NVQlNDUklCRVJfVE9UQUxfRlJFRVpFX0RVUkFUSU9OEAQSJwojQ0xJRU5UX1ZJREVPX1NVQlNDUklCRVJfUEFVU0VfQ09VTlQQBRIxCi1DTElFTlRfVklERU9fU1VCU0NSSUJFUl9UT1RBTF9QQVVTRVNfRFVSQVRJT04QBhItCilDTElFTlRfQVVESU9fU1VCU0NSSUJFUl9DT05DRUFMRURfU0FNUExFUxAHEjQKMENMSUVOVF9BVURJT19TVUJTQ1JJQkVSX1NJTEVOVF9DT05DRUFMRURfU0FNUExFUxAIEi4KKkNMSUVOVF9BVURJT19TVUJTQ1JJQkVSX0NPTkNFQUxNRU5UX0VWRU5UUxAJEi4KKkNMSUVOVF9BVURJT19TVUJTQ1JJQkVSX0lOVEVSUlVQVElPTl9DT1VOVBAKEjcKM0NMSUVOVF9BVURJT19TVUJTQ1JJQkVSX1RPVEFMX0lOVEVSUlVQVElPTl9EVVJBVElPThALEikKJUNMSUVOVF9TVUJTQ1JJQkVSX0pJVFRFUl9CVUZGRVJfREVMQVkQDBIxCi1DTElFTlRfU1VCU0NSSUJFUl9KSVRURVJfQlVGRkVSX0VNSVRURURfQ09VTlQQDRJACjxDTElFTlRfVklERU9fUFVCTElTSEVSX1FVQUxJVFlfTElNSVRBVElPTl9EVVJBVElPTl9CQU5EV0lEVEgQDhI6CjZDTElFTlRfVklERU9fUFVCTElTSEVSX1FVQUxJVFlfTElNSVRBVElPTl9EVVJBVElPTl9DUFUQDxI8CjhDTElFTlRfVklERU9fUFVCTElTSEVSX1FVQUxJVFlfTElNSVRBVElPTl9EVVJBVElPTl9PVEhFUhAQEhEKDVBVQkxJU0hFUl9SVFQQERITCg9TRVJWRVJfTUVTSF9SVFQQEhISCg5TVUJTQ1JJQkVSX1JUVBATEiYKIU1FVFJJQ19MQUJFTF9QUkVERUZJTkVEX01BWF9WQUxVRRCAIEKDAQoLY29tLmxpdmVraXRCE0xpdmVraXRNZXRyaWNzUHJvdG9QAVojZ2l0aHViLmNvbS9saXZla2l0L3Byb3RvY29sL2xpdmVraXSiAgNMWFiqAgdMaXZla2l0ygIHTGl2ZWtpdOICE0xpdmVraXRcR1BCTWV0YWRhdGHqAgdMaXZla2l0YgZwcm90bzM", [file_google_protobuf_timestamp, file_logger_options]);

/**
 * @generated from message livekit.MetricsBatch
 */
export type MetricsBatch = Message<"livekit.MetricsBatch"> & {
  /**
   * time at which this batch is sent based on a monotonic clock (millisecond resolution)
   *
   * @generated from field: int64 timestamp_ms = 1 [jstype = JS_STRING];
   */
  timestampMs: string;

  /**
   * @generated from field: google.protobuf.Timestamp normalized_timestamp = 2;
   */
  normalizedTimestamp?: Timestamp | undefined;

  /**
   * To avoid repeating string values, we store them in a separate list and reference them by index
   * This is useful for storing participant identities, track names, etc.
   * There is also a predefined list of labels that can be used to reference common metrics.
   * They have reserved indices from 0 to (METRIC_LABEL_PREDEFINED_MAX_VALUE - 1).
   * Indexes pointing at str_data should start from METRIC_LABEL_PREDEFINED_MAX_VALUE,
   * such that str_data[0] == index of METRIC_LABEL_PREDEFINED_MAX_VALUE.
   *
   * @generated from field: repeated string str_data = 3;
   */
  strData: string[];

  /**
   * @generated from field: repeated livekit.TimeSeriesMetric time_series = 4;
   */
  timeSeries: TimeSeriesMetric[];

  /**
   * @generated from field: repeated livekit.EventMetric events = 5;
   */
  events: EventMetric[];
};

/**
 * Describes the message livekit.MetricsBatch.
 * Use `create(MetricsBatchSchema)` to create a new message.
 */
export const MetricsBatchSchema: GenMessage<MetricsBatch> = /*@__PURE__*/
  messageDesc(file_livekit_metrics, 0);

/**
 * @generated from message livekit.TimeSeriesMetric
 */
export type TimeSeriesMetric = Message<"livekit.TimeSeriesMetric"> & {
  /**
   * Metric name e.g "speech_probablity". The string value is not directly stored in the message, but referenced by index
   * in the `str_data` field of `MetricsBatch`
   *
   * @generated from field: uint32 label = 1;
   */
  label: number;

  /**
   * index into `str_data`
   *
   * @generated from field: uint32 participant_identity = 2;
   */
  participantIdentity: number;

  /**
   * index into `str_data`
   *
   * @generated from field: uint32 track_sid = 3;
   */
  trackSid: number;

  /**
   * @generated from field: repeated livekit.MetricSample samples = 4;
   */
  samples: MetricSample[];

  /**
   * index into 'str_data'
   *
   * @generated from field: uint32 rid = 5;
   */
  rid: number;
};

/**
 * Describes the message livekit.TimeSeriesMetric.
 * Use `create(TimeSeriesMetricSchema)` to create a new message.
 */
export const TimeSeriesMetricSchema: GenMessage<TimeSeriesMetric> = /*@__PURE__*/
  messageDesc(file_livekit_metrics, 1);

/**
 * @generated from message livekit.MetricSample
 */
export type MetricSample = Message<"livekit.MetricSample"> & {
  /**
   * time of metric based on a monotonic clock (in milliseconds)
   *
   * @generated from field: int64 timestamp_ms = 1 [jstype = JS_STRING];
   */
  timestampMs: string;

  /**
   * @generated from field: google.protobuf.Timestamp normalized_timestamp = 2;
   */
  normalizedTimestamp?: Timestamp | undefined;

  /**
   * @generated from field: float value = 3;
   */
  value: number;
};

/**
 * Describes the message livekit.MetricSample.
 * Use `create(MetricSampleSchema)` to create a new message.
 */
export const MetricSampleSchema: GenMessage<MetricSample> = /*@__PURE__*/
  messageDesc(file_livekit_metrics, 2);

/**
 * @generated from message livekit.EventMetric
 */
export type EventMetric = Message<"livekit.EventMetric"> & {
  /**
   * @generated from field: uint32 label = 1;
   */
  label: number;

  /**
   * index into `str_data`
   *
   * @generated from field: uint32 participant_identity = 2;
   */
  participantIdentity: number;

  /**
   * index into `str_data`
   *
   * @generated from field: uint32 track_sid = 3;
   */
  trackSid: number;

  /**
   * start time of event based on a monotonic clock (in milliseconds)
   *
   * @generated from field: int64 start_timestamp_ms = 4 [jstype = JS_STRING];
   */
  startTimestampMs: string;

  /**
   * end time of event based on a monotonic clock (in milliseconds), if needed
   *
   * @generated from field: optional int64 end_timestamp_ms = 5 [jstype = JS_STRING];
   */
  endTimestampMs?: string | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp normalized_start_timestamp = 6;
   */
  normalizedStartTimestamp?: Timestamp | undefined;

  /**
   * @generated from field: optional google.protobuf.Timestamp normalized_end_timestamp = 7;
   */
  normalizedEndTimestamp?: Timestamp | undefined;

  /**
   * @generated from field: string metadata = 8;
   */
  metadata: string;

  /**
   * index into 'str_data'
   *
   * @generated from field: uint32 rid = 9;
   */
  rid: number;
};

/**
 * Describes the message livekit.EventMetric.
 * Use `create(EventMetricSchema)` to create a new message.
 */
export const EventMetricSchema: GenMessage<EventMetric> = /*@__PURE__*/
  messageDesc(file_livekit_metrics, 3);

/**
 * @generated from message livekit.MetricsRecordingHeader
 */
export type MetricsRecordingHeader = Message<"livekit.MetricsRecordingHeader"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;

  /**
   * milliseconds
   *
   * @generated from field: uint64 duration = 3 [jstype = JS_STRING];
   */
  duration: string;

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 4;
   */
  startTime?: Timestamp | undefined;

  /**
   * @generated from field: map<string, string> room_tags = 5;
   */
  roomTags: { [key: string]: string };

  /**
   * @generated from field: string room_name = 6;
   */
  roomName: string;

  /**
   * @generated from field: google.protobuf.Timestamp room_start_time = 7;
   */
  roomStartTime?: Timestamp | undefined;

  /**
   * @generated from field: string job_id = 8;
   */
  jobId: string;
};

/**
 * Describes the message livekit.MetricsRecordingHeader.
 * Use `create(MetricsRecordingHeaderSchema)` to create a new message.
 */
export const MetricsRecordingHeaderSchema: GenMessage<MetricsRecordingHeader> = /*@__PURE__*/
  messageDesc(file_livekit_metrics, 4);

/**
 * index from [0: MAX_LABEL_PREDEFINED_MAX_VALUE) are for predefined labels (`MetricLabel`)
 *
 * @generated from enum livekit.MetricLabel
 */
export enum MetricLabel {
  /**
   * time to first token from LLM
   *
   * @generated from enum value: AGENTS_LLM_TTFT = 0;
   */
  AGENTS_LLM_TTFT = 0,

  /**
   * time to final transcription
   *
   * @generated from enum value: AGENTS_STT_TTFT = 1;
   */
  AGENTS_STT_TTFT = 1,

  /**
   * time to first byte
   *
   * @generated from enum value: AGENTS_TTS_TTFB = 2;
   */
  AGENTS_TTS_TTFB = 2,

  /**
   * Number of video freezes
   *
   * @generated from enum value: CLIENT_VIDEO_SUBSCRIBER_FREEZE_COUNT = 3;
   */
  CLIENT_VIDEO_SUBSCRIBER_FREEZE_COUNT = 3,

  /**
   * total duration of freezes
   *
   * @generated from enum value: CLIENT_VIDEO_SUBSCRIBER_TOTAL_FREEZE_DURATION = 4;
   */
  CLIENT_VIDEO_SUBSCRIBER_TOTAL_FREEZE_DURATION = 4,

  /**
   * number of video pauses
   *
   * @generated from enum value: CLIENT_VIDEO_SUBSCRIBER_PAUSE_COUNT = 5;
   */
  CLIENT_VIDEO_SUBSCRIBER_PAUSE_COUNT = 5,

  /**
   * total duration of pauses
   *
   * @generated from enum value: CLIENT_VIDEO_SUBSCRIBER_TOTAL_PAUSES_DURATION = 6;
   */
  CLIENT_VIDEO_SUBSCRIBER_TOTAL_PAUSES_DURATION = 6,

  /**
   * number of concealed (synthesized) audio samples
   *
   * @generated from enum value: CLIENT_AUDIO_SUBSCRIBER_CONCEALED_SAMPLES = 7;
   */
  CLIENT_AUDIO_SUBSCRIBER_CONCEALED_SAMPLES = 7,

  /**
   * number of silent concealed samples
   *
   * @generated from enum value: CLIENT_AUDIO_SUBSCRIBER_SILENT_CONCEALED_SAMPLES = 8;
   */
  CLIENT_AUDIO_SUBSCRIBER_SILENT_CONCEALED_SAMPLES = 8,

  /**
   * number of concealment events
   *
   * @generated from enum value: CLIENT_AUDIO_SUBSCRIBER_CONCEALMENT_EVENTS = 9;
   */
  CLIENT_AUDIO_SUBSCRIBER_CONCEALMENT_EVENTS = 9,

  /**
   * number of interruptions
   *
   * @generated from enum value: CLIENT_AUDIO_SUBSCRIBER_INTERRUPTION_COUNT = 10;
   */
  CLIENT_AUDIO_SUBSCRIBER_INTERRUPTION_COUNT = 10,

  /**
   * total duration of interruptions
   *
   * @generated from enum value: CLIENT_AUDIO_SUBSCRIBER_TOTAL_INTERRUPTION_DURATION = 11;
   */
  CLIENT_AUDIO_SUBSCRIBER_TOTAL_INTERRUPTION_DURATION = 11,

  /**
   * total time spent in jitter buffer
   *
   * @generated from enum value: CLIENT_SUBSCRIBER_JITTER_BUFFER_DELAY = 12;
   */
  CLIENT_SUBSCRIBER_JITTER_BUFFER_DELAY = 12,

  /**
   * total time spent in jitter buffer
   *
   * @generated from enum value: CLIENT_SUBSCRIBER_JITTER_BUFFER_EMITTED_COUNT = 13;
   */
  CLIENT_SUBSCRIBER_JITTER_BUFFER_EMITTED_COUNT = 13,

  /**
   * total duration spent in bandwidth quality limitation
   *
   * @generated from enum value: CLIENT_VIDEO_PUBLISHER_QUALITY_LIMITATION_DURATION_BANDWIDTH = 14;
   */
  CLIENT_VIDEO_PUBLISHER_QUALITY_LIMITATION_DURATION_BANDWIDTH = 14,

  /**
   * total duration spent in cpu quality limitation
   *
   * @generated from enum value: CLIENT_VIDEO_PUBLISHER_QUALITY_LIMITATION_DURATION_CPU = 15;
   */
  CLIENT_VIDEO_PUBLISHER_QUALITY_LIMITATION_DURATION_CPU = 15,

  /**
   * total duration spent in other quality limitation
   *
   * @generated from enum value: CLIENT_VIDEO_PUBLISHER_QUALITY_LIMITATION_DURATION_OTHER = 16;
   */
  CLIENT_VIDEO_PUBLISHER_QUALITY_LIMITATION_DURATION_OTHER = 16,

  /**
   * Publisher RTT (participant -> server)
   *
   * @generated from enum value: PUBLISHER_RTT = 17;
   */
  PUBLISHER_RTT = 17,

  /**
   * RTT between publisher node and subscriber node (could involve intermedia node(s))
   *
   * @generated from enum value: SERVER_MESH_RTT = 18;
   */
  SERVER_MESH_RTT = 18,

  /**
   * Subscribe RTT (server -> participant)
   *
   * @generated from enum value: SUBSCRIBER_RTT = 19;
   */
  SUBSCRIBER_RTT = 19,

  /**
   * @generated from enum value: METRIC_LABEL_PREDEFINED_MAX_VALUE = 4096;
   */
  METRIC_LABEL_PREDEFINED_MAX_VALUE = 4096,
}

/**
 * Describes the enum livekit.MetricLabel.
 */
export const MetricLabelSchema: GenEnum<MetricLabel> = /*@__PURE__*/
  enumDesc(file_livekit_metrics, 0);

